import { render, staticRenderFns } from "./TableRowAvgDollarsDiscounted.vue?vue&type=template&id=4549850e&lang=pug&"
import script from "./TableRowAvgDollarsDiscounted.vue?vue&type=script&lang=js&"
export * from "./TableRowAvgDollarsDiscounted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4549850e')) {
      api.createRecord('4549850e', component.options)
    } else {
      api.reload('4549850e', component.options)
    }
    module.hot.accept("./TableRowAvgDollarsDiscounted.vue?vue&type=template&id=4549850e&lang=pug&", function () {
      api.rerender('4549850e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/tracking-sheet/table-rows/TableRowAvgDollarsDiscounted.vue"
export default component.exports